import { useContext, useEffect, useRef, useState } from "react"
import { api } from "../../../api/api"
import { mascaraMoeda, maskCurrency } from "../../../utils/utils"
import { Toast } from "../../../utils/Toast"
import { DateTime } from "luxon"
import { GlobalContext } from "../../../context/GlobalContext"
import useSWR, { useSWRConfig } from "swr"
import { IoPrintSharp } from "react-icons/io5"
import { FiArchive, FiDollarSign } from "react-icons/fi"
import { sendPrintSafeClose, sendPrintSafeRegister } from "../../../reporting/print"

let isRequest = false

export function OpenSafe({ reload, viewRegisters, isOpen }) {
  const { mutate } = useSWRConfig()

  const refLoadingOpenSafe = useRef(false)
  const { isAccess } = useContext(GlobalContext)
  const [registers, setRegisters] = useState([])
  const [report, setReport] = useState({
    totalCard: 0,
    totalMoney: 0,
    totalPix: 0,
  })

  useSWR('/safe/load/data', async () => {
    await Promise.all([
      findValues(),
      lastRegisters(),
    ])
  })

  const [state, setState] = useState({
    pricing: 0,
    description: ''
  })

  async function openSafe() {
    try {
      if (refLoadingOpenSafe.current === true) {
        return Toast.warning('Estamos abrindo o caixa aguarde um momento.')
      }

      refLoadingOpenSafe.current = true

      if (isRequest) {
        return Toast.warning('Aguarde um momento, estamos salvando a informação.')
      }

      isRequest = true

      await api.post('/safe/open', {
        pricing: state.pricing,
        description: state.description
      })

      await mutate('/safe/load/data')
      await mutate('/safe')

      await reload()

      isRequest = false

      setState({ pricing: 0, description: '' })
      refLoadingOpenSafe.current = false

      Toast.success('Caixa aberto com sucesso')
    } catch (error) {
      refLoadingOpenSafe.current = false

    } finally {
      refLoadingOpenSafe.current = false
      isRequest = false
    }
  }

  async function findValues() {
    const response = await api('/safe/reporting')

    const data = response.data[0]

    if (!data) { return; }

    setReport({
      ...report,
      ...data,
    })
  }

  async function lastRegisters() {
    const response = await api('/safe/last/registers')
    setRegisters(response.data)
  }

  useEffect(() => {
    lastRegisters()
  }, [isOpen])

  return (
    <div className="modal fade admin-form-modal safe-registers-modal" id="modalIsOpenSafe" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="modalIsOpenSafeLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div className="safe-modal-heading"><span>{viewRegisters ? <FiArchive /> : <FiDollarSign />}</span><div><h5 className="modal-title" id="modalIsOpenSafeLabel">{viewRegisters ? 'Registros do caixa' : 'Abrir caixa'}</h5><p>{viewRegisters ? 'Consulte e imprima os últimos fechamentos' : 'Informe o saldo disponível para iniciar a operação'}</p></div></div>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          {!viewRegisters && (
            <div className="modal-body safe-open-modal-body">
              <div className="safe-modal-notice" role="alert"><FiDollarSign /><div><strong>Caixa fechado</strong><span>Declare o valor inicial antes de registrar movimentações.</span></div></div>
              <div className="safe-open-form">
                <label htmlFor="safe-opening-value"><span>Valor inicial</span><input id="safe-opening-value" type="text" value={maskCurrency(state.pricing)} onChange={(e) => setState({ ...state, pricing: mascaraMoeda(e.target.value) })} /></label>
                <label htmlFor="safe-opening-description"><span>Descrição</span><textarea value={state.description} onChange={(e) => setState({ ...state, description: e.target.value })} id="safe-opening-description" rows="3" placeholder="Ex.: Troco inicial do caixa" /></label>
              </div>
              {isAccess('caixa', 'open_safe') && <div className="safe-modal-actions"><button className="admin-primary-button" onClick={() => openSafe()}>Abrir caixa</button></div>}
            </div>
          )}

          {viewRegisters && (
            <div className="modal-body safe-registers-modal-body">
              <div className="safe-modal-section-heading"><div><strong>Histórico recente</strong><span>Últimos 5 registros</span></div><FiArchive /></div>
              <div className="admin-table-wrap safe-registers-table-wrap">
                <table className="admin-table safe-registers-table">
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Data de abertura</th>
                      <th>Data de fechamento</th>
                      <th>Imprimir Registros</th>
                      <th>Imprimir fechamento</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registers.map((value) => {
                      return (
                        <tr key={value.id}>
                          <td data-label="Status"><span className={`admin-status ${value.close ? 'inactive' : 'active'}`}>{value.close ? 'Fechado' : 'Aberto'}</span></td>
                          <td data-label="Abertura">{DateTime.fromISO(value.open).toFormat('dd/MM/yyyy HH:mm:ss')}</td>
                          <td data-label="Fechamento">{value.close ? DateTime.fromISO(value.close).toLocal().toFormat('dd/MM/yyyy HH:mm:ss') : '-'}</td>
                          <td data-label="Movimentações">{value.close ? <button className="safe-print-button" onClick={() => sendPrintSafeRegister(value.id)} aria-label="Imprimir movimentações"><IoPrintSharp /> <span>Imprimir</span></button> : '-'}</td>
                          <td data-label="Fechamento">{value.close ? <button className="safe-print-button" onClick={() => sendPrintSafeClose(value.id)} aria-label="Imprimir fechamento"><IoPrintSharp /> <span>Imprimir</span></button> : '-'}</td>
                        </tr>
                      )
                    })}

                  </tbody>
                </table>
              </div>
              {registers.length === 0 && <div className="admin-empty safe-modal-empty"><FiArchive size={24} /><strong>Nenhum registro encontrado</strong><span>Os fechamentos aparecerão aqui.</span></div>}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
